"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ImmutableTermIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableTermIdMap"));

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var discountAdapter = function discountAdapter(merchandiseId, termId, currentSubscriptions, merchandiseMap) {
  var termDiscount = _ImmutableTermIdMap.default[termId].discountPercent; // Initially we'll only do this for seated products
  // We'll also do this for Marketing Starter contacts, so that they
  // can see the discount they'll get on those contacts

  if (!currentSubscriptions || _MerchandiseIdLists.SEATED_MERCHANDISE_IDS.indexOf(merchandiseId) === -1 && merchandiseId !== MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS) {
    return termDiscount;
  }

  if (merchandiseId in currentSubscriptions) {
    return currentSubscriptions[merchandiseId].discountPercentage / 100;
  } // Because of the experiment we ran where the SKU and contacts were discounted
  // differently, if we can't find the contacts discount don't look
  // for the parent SKU's


  if (merchandiseId === MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS) {
    return termDiscount;
  }

  var parentDiscount = null;
  var parentItemIds = merchandiseMap[merchandiseId] && merchandiseMap[merchandiseId].parentItemIds || [];
  parentItemIds.forEach(function (parentProductId) {
    if (parentProductId in currentSubscriptions) {
      parentDiscount = currentSubscriptions[parentProductId].discountPercentage / 100;
    }
  });
  if (parentDiscount) return parentDiscount;
  return termDiscount;
};

var _default = discountAdapter;
exports.default = _default;
module.exports = exports.default;